<h1 mat-dialog-title class="dialog-title">
  {{ 'modal.file.uploadShareLevel' | transloco }}: <strong>{{ data.fileName }}</strong>
</h1>

<div mat-dialog-content>

  <mat-form-field appearance="fill">
    <mat-label>Share Level</mat-label>
    <mat-select [(value)]="data.shareLevel">
      <mat-option value="PUB">PUB</mat-option>
      <mat-option value="PRV">PRV</mat-option>
      <mat-option value="DOM">DOM</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Share Level Edit</mat-label>
    <mat-select [(value)]="data.shareLevelEdit">
      <mat-option value="PUB">PUB</mat-option>
      <mat-option value="PRV">PRV</mat-option>
      <mat-option value="DOM">DOM</mat-option>
    </mat-select>
  </mat-form-field>

</div>

<div class="dialog-buttons">
  <button mat-button class="cancel" (click)="onCancel()">{{'recordsManagement.delete.cancel' | transloco}}</button>
  <button mat-button class="confirm" (click)="onConfirm()">{{'recordsManagement.delete.confirm' | transloco}}</button>
</div>